import React, { FC } from 'react'
import { SanityLargeTeaser } from '../../../../../types/generated/graphql-types'
import { mapSanityLargeTeaserToLargeTeaserProps } from '../../../../mapping/LargeTeaserMapper'
import { BlockWithId } from '../../../../utilities/blockId'
import { LargeTeaser } from '../../../blocks/LargeTeaser'
import { Section } from '../../../Section'

export const LargeTeaserSerializer: FC<SanityLargeTeaser & BlockWithId> = ({
  id,
  ...props
}) => (
  <Section id={id}>
    <LargeTeaser {...mapSanityLargeTeaserToLargeTeaserProps(props)} />
  </Section>
)
